module.exports = __webpack_public_path__ + "static/media/wmsui32_2219.94d970d6.ico";